var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, Type } from '@decahedron/entity';
var MarketingChannels = /** @class */ (function (_super) {
    __extends(MarketingChannels, _super);
    function MarketingChannels() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tePalvelut = false;
        _this.jobcluster = false;
        return _this;
    }
    return MarketingChannels;
}(Entity));
export { MarketingChannels };
var FeatureConfiguration = /** @class */ (function (_super) {
    __extends(FeatureConfiguration, _super);
    function FeatureConfiguration() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.bot = false;
        _this.eb = false;
        _this.candidateIsolation = false;
        _this.marketingChannels = new MarketingChannels();
        _this.formResponseDownload = false;
        _this.exportIntegrations = false;
        _this.formEditor = false;
        _this.jobLists = false;
        return _this;
    }
    __decorate([
        Type(MarketingChannels),
        __metadata("design:type", MarketingChannels)
    ], FeatureConfiguration.prototype, "marketingChannels", void 0);
    return FeatureConfiguration;
}(Entity));
export { FeatureConfiguration };
